import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    card: {
        borderRadius: 10,
        padding: 20,
        paddingBottom: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            padding: 40
        },
        [theme.breakpoints.down('xs')]: {
            padding: 20,
            paddingBottom: 10,
        },
    },
    cardTitle: {
        fontFamily: 'Raleway, sans-serif !important',
        fontWeight: "600 !important",
        fontSize: '1.8rem !important',
        marginBottom: '6px !important',
        color: "#333333",
        textAlign: 'center',
    },
    cardSubtitle: {
        color: '#ba4419',
        fontSize: '1.3em !important',
        fontWeight: 600,
        textAlign: 'center',
    },
    bulletList: {
        marginBottom: 25,
        paddingLeft: 16,
        marginTop: 15,
        fontSize: '1.2em',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: 8,
        },
    },
    listItem: {
        padding: 0,
        paddingBottom: '0px !important',
        alignItems: 'center',
        '& .MuiListItemText-primary': {
            marginLeft: -30,
            lineHeight: '1.2em',
        },
    },
    icon: {
        color: "#66bb6a",
        fontSize: '1.3rem',
        minWidth: 24,
        marginLeft: -10,
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 60,
        gap: '0px',
        flexWrap: 'wrap',
        padding: 0,
    },
    contactButton: {
        color: '#fff !important',
        fontWeight: 600,
        textTransform: "none !important",
        minWidth: 130,
        width: '50%',
        height: 40,
        '&:first-of-type': {
            background: '#3e495f',
            borderRight: '2px solid white',
            borderBottomLeftRadius: '5px',
            borderTopLeftRadius: '5px',
            '&:hover, &:focus': {
                backgroundColor: '#2c313c',
            },
        },
        '&:last-of-type': {
            backgroundColor: '#114796',
            borderBottomRightRadius: '5px',
            borderTopRightRadius: '5px',
            '&:hover, &:focus': {
                backgroundColor: '#0b3879',
            },
        },
    },
    images: {
        width: '100%',
        height: 'auto',
        maxWidth: '485px',
        borderRadius: '5px !important',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
        },
    },
    divider: {
        height: 2,
        backgroundColor: '#e0e0e0',
        margin: '20px 0px 5px 0px',
        [theme.breakpoints.down('xs')]: {
            margin: '18px 0px 3px 0px',
        },
    },
}));

export default useStyles;
